import Vue from 'vue'
import Vuex from 'vuex'
import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import OidcSettings from './oidc-config'
import CacheStore from './cache';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    oidcStore: vuexOidcCreateStoreModule(OidcSettings),
    cache: CacheStore,
  },
});
